import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'BookingMobileToolbar' }

import { computed } from 'vue'
import type { PropType } from 'vue'
import moment from 'moment'
import { MAX_RANGE_DAYS, computeRangeWindow } from '@/util/bookingRange'
import type { BookingRange } from '@/util/bookingRange'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  range: { type: String as PropType<BookingRange>, required: true },
  rangeOptions: { type: Array as PropType<{ value: BookingRange; label: string }[]>, required: true },
  // The view's current date (YYYY-MM-DD)
  anchor: { type: String, required: true },
  firstDayOfWeek: { type: [Number, String], default: null },
  customRange: { type: Array as PropType<string[]>, default: () => [] },
  filterCount: { type: Number, default: 0 },
  filtersOpen: { type: Boolean, default: false },
  showFilterButton: { type: Boolean, default: true },
  // Views with their own phone breakpoint (Resource calendar: < 640px) show it themselves
  alwaysShow: { type: Boolean, default: false }
},
  emits: ["range", "navigate", "custom-range", "update:filtersOpen"],
  setup(__props, { emit }: { emit: ({
  (e: 'range', value: BookingRange): void
  (e: 'navigate', value: string): void
  (e: 'custom-range', value: string[]): void
  (e: 'update:filtersOpen', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const rangeWindow = computed(() => computeRangeWindow(
  props.range, props.anchor, props.customRange, props.firstDayOfWeek as number | string | null
))

const navMode = computed(() => (props.range === 'week' || props.range === 'month' ? props.range : 'day'))

// Week shows its first day, so the label can read "Sep 27 – Oct 3"
const navValue = computed(() => (props.range === 'week' ? rangeWindow.value.startDate : props.anchor))

// Element picker format tokens; [..] is literal text (the week's end date)
const navFormat = computed(() => {
  if (props.range === 'month') return 'MMM yyyy'
  if (props.range === 'week') return 'MMM d [– ' + moment(rangeWindow.value.endDate, 'YYYY-MM-DD').format('MMM D') + ']'
  return 'MMM d'
})

return { __sfc: true,props, emit, rangeWindow, navMode, navValue, navFormat, MAX_RANGE_DAYS }
}

})